// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

// Initialize Firebase

var firebaseConfig = {
  apiKey: "AIzaSyA68pMwGsPH9I2X9ba8XHaoHReJBY5GqZM",
  authDomain: "darunday-web-portfolio.firebaseapp.com",
  projectId: "darunday-web-portfolio",
  storageBucket: "darunday-web-portfolio.appspot.com",
  messagingSenderId: "594187807257",
  appId: "1:594187807257:web:5e3ee95102012cf25ed888",
  measurementId: "G-L5CM4GC52V",
};

//Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore();

//Variable to access database collection

export { db };
